module.exports = __webpack_public_path__ + "/login_ui/img/ly-02815876a6a4663990241c78169fe71a.svg";